import React from 'react';
import { AIcon } from '../AIcon';
import * as Styled from './ACarouselArrow.styles';
import { ACarouselArrowProps, ACarouselArrowDirection } from './ACarouselArrow.types';

export const ACarouselArrow: React.FC<ACarouselArrowProps> = ({
  direction = ACarouselArrowDirection.Right,
  disabled = false,
  transparent = false,
  onClick,
  className,
  ...rest
}) => {
  const iconName = direction === ACarouselArrowDirection.Right ? 'icon-arrow-right' : 'icon-arrow-left';
  const ariaLabel = direction === ACarouselArrowDirection.Right ? 'Next' : 'Previous';

  return (
    <Styled.ArrowButton
      onClick={onClick}
      disabled={disabled}
      $transparent={transparent}
      className={className}
      aria-label={ariaLabel}
      type="button"
      {...rest}
    >
      <AIcon icon={iconName} aria-hidden="true" />
    </Styled.ArrowButton>
  );
};